export default `
  mutation validateUsersSubscriptions($users: [StripeUserInput]!) {
    validateUsersSubscriptions(users: $users) {
      success
      message
      users {
        email
        status
      }
    }
  }
`
